module.exports = __webpack_public_path__ + "media/assets/avia/search/flex-date-676f40485971d9b2fbed481d4a4d3801.png";